<template>
  <el-row>
    <el-card shadow="never" class="mt-0 card-promo">
      <el-radio-group
        v-model="Promo.promoTargetCart.target.targetType"
        style="width: 100%"
      >
        <template v-for="(formradio, idx) in formRadio">
          <el-row :key="idx" type="flex" justify="space-between">
            <el-col :span="6">
              <el-radio :label="formradio.value" class="mt-2">{{
                formradio.label
              }}</el-radio>
            </el-col>
            <el-col :span="13">
              <el-form-item size="small" style="margin: 0">
                <el-row
                  type="flex"
                  justify="space-between"
                  style="flex-wrap: wrap"
                >
                  <template v-for="(form, idx) in formradio.form">
                    <el-col
                      :span="form.span"
                      style="margin-bottom: 18px"
                      :key="idx"
                    >
                      <el-input
                        v-if="
                          form.type == 'text' ||
                            form.type == 'password' ||
                            form.type == 'number'
                        "
                        v-model="Promo.promoTargetCart.target[form.id]"
                        :placeholder="form.placeholder"
                        :type="form.type"
                        :disabled="disabledField(formradio.value)"
                      ></el-input>
                      <el-select
                        v-else-if="form.type == 'select'"
                        v-model="Promo.promoTargetCart.target[form.id]"
                        :multiple="form.multiple"
                        style="width: 100%"
                        filterable
                        remote
                        :remote-method="form.onSearch"
                        :loading="form.onLoading"
                        :disabled="disabledField(formradio.value)"
                      >
                        <el-option
                          v-for="item in form.data"
                          :key="item.value"
                          :label="item.name"
                          :value="item.value"
                        ></el-option>
                        <el-row
                          v-if="form.loadMore"
                          type="flex"
                          justify="center"
                        >
                          <el-button
                            :loading="form.onLoading"
                            size="mini"
                            round
                            @click="form.loadMore"
                            >Load More</el-button
                          >
                        </el-row>
                      </el-select>
                    </el-col>
                  </template>
                </el-row>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
      </el-radio-group>
    </el-card>
  </el-row>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  props: ["Promo"],
  data() {
    return {
      limitBranch: 25,
      limitCustomer: 25
    };
  },
  computed: {
    ...mapState({
      branchs: state => state.branch.branchs,
      customers: state => state.customer.customers
    }),
    formRadio() {
      return [
        {
          label: "RGM",
          value: "rgm",
          form: [
            {
              type: "select",
              id: "rgm",
              label: "",
              rules: [],
              data: [
                {
                  name: "RGM 1",
                  value: "rgm1"
                },
                {
                  name: "RGM 2",
                  value: "rgm2"
                }
              ]
            }
          ]
        },
        {
          label: "Branch",
          value: "branch",
          form: [
            {
              type: "select",
              id: "branch",
              label: "",
              rules: [],
              data: this.branchs.data.map(item => {
                item.name = `${item.branchCode} - ${item.branch}`;
                item.value = item.branchCode;
                return item;
              }),
              loadMore: this.loadMoreBranch,
              onSearch: this.onSearchBranch,
              onLoading: this.branchs.isLoading
            }
          ]
        },
        {
          label: "Customer Class",
          value: "customerClass",
          form: [
            {
              type: "select",
              id: "customerClass",
              label: "",
              rules: [],
              data: [
                {
                  name: "Traditional Market",
                  value: "Traditional Market"
                },
                {
                  name: "Modern Market",
                  value: "Modern Market"
                },
              ]
            }
          ]
        },
        {
          label: "Customer Type",
          value: "customerType",
          form: [
            {
              type: "select",
              id: "customerType",
              label: "",
              rules: [],
              data: [
                {
                  name: "Customer Type 1",
                  value: "customerType1"
                },
                {
                  name: "Customer Type 2",
                  value: "customerType2"
                }
              ]
            }
          ]
        },
        {
          label: "Oracle Customer ID",
          value: "oracleCustomerId",
          form: [
            {
              type: "select",
              id: "oracleCustomerId",
              label: "",
              rules: [],
              multiple: true,
              data: this.customers.data.map(item => {
                item.name = `${item.oracleCustomerId} - ${item.customerName}`;
                item.value = item.oracleCustomerId;
                return item;
              }),
              loadMore: this.loadMoreCustomer,
              onSearch: this.onSearchCustomer,
              onLoading: this.customers.isLoading
            }
          ]
        }
      ];
    }
  },
  methods: {
    ...mapActions({
      getBranch: "branch/GetBranchs",
      getOwners: "customer/GetOwners"
    }),
    disabledField(value) {
      return this.Promo.promoTargetCart.target.targetType !== value
    },
    onSearchBranchs(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getBranch(option);
    },
    loadMoreBranch() {
      this.limitBranch += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitBranch
        }
      };
      this.getBranch(option);
    },
    onSearchCustomer(search) {
      let option = {
        params: {
          page: 1,
          limit: 25,
          search: search
        }
      };
      this.getOwners(option);
    },
    loadMoreCustomer() {
      this.limitCustomer += 25;
      let option = {
        params: {
          page: 1,
          limit: this.limitCustomer
        }
      };
      this.getOwners(option);
    }
  },
  created() {
    let option = {
      params: {
        page: 1,
        limit: 25
      }
    };
    this.getBranch(option);
    this.getOwners(option);
  }
};
</script>

<style>
.tab-promo /deep/ .el-tabs__item {
  padding: 0px 20px !important;
}
.tab-promo /deep/ .el-tabs__item.is-active {
  color: white !important;
  background-color: #2356c9;
  padding: 0px 20px !important;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  font-weight: bold;
}
.tab-promo /deep/ .el-tabs__header.is-top {
  margin: 0 !important;
}
.card-promo {
  background-color: #f6f6f6 !important;
}
</style>
